import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { ReactComponent as NoReportIcon } from 'icons/noReport.svg';


const NoReportTab = ({ classes }) => (
  <div className={classes.noContent}>
    <NoReportIcon className={classes.noContentImage} />
    <div className={classes.noContentDescription}>
      <div className={classes.noContentDescriptionTitle}>Generate your report</div>
      <div>Select an account and hit generate report</div>
    </div>
  </div>
);

NoReportTab.propTypes = {
  classes: PropTypes.shape({}).isRequired,
};

const styles = theme => ({
  noContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    margin: '100px 0 80px 0',
  },
  noContentImage: {
    width: '380px',
  },
  noContentDescription: {
    color: theme.palette.secondary.text,
    fontSize: '0.875rem',
    marginTop: '2rem',
  },
  noContentDescriptionTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
  },
});

export default compose(withStyles(styles))(NoReportTab);
